export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/enums/CartItemType.ts